console.info("Contact Form v2.4");
if (typeof app === "undefined") {
  var app = {
    config: {
      projectName: null,
    },
    private: {
      productCategory: {
        do_aac: function () {
          app.private.productCategory.undo();
          let aacTopics = app.private.getAacTopics();

          TDForm.helper.updateSelect("topic", aacTopics);
          TDForm.helper.showField("product_interest-container", true);
        },
        do_bm: function () {
          app.private.productCategory.undo();
          let bmTopics = app.private.getBmTopics();
          TDForm.helper.updateSelect("topic", bmTopics);
          TDForm.helper.showField("product_interest-container", true);
        },
        undo: function () {
          TDForm.helper.updateSelect("topic", []);
          TDForm.helper.hideField("product_interest-container");
        },
      },
      getAacTopics: function () {
        let region = document.getElementById("form_region").value;
        if (region === "ca" || region === "us") {
          return [
            { value: "buy-product", name: "I wish to buy a product" },
            { value: "order-question", name: "I have a question about an order I’ve made" },
            { value: "license-issue", name: "I have an issue with my license" },
            { value: "restore-data", name: "I want to restore my user data" },
            { value: "eye-tracking-issue", name: "My eye tracking is not working" },
            { value: "device-issue", name: "My device is malfunctioning" },
            { value: "trial-device", name: "I have a question regarding my trial device" },
            { value: "funding", name: "I have a question related to Funding" },
            { value: "other", name: "Other Issues" },
          ];
        } else {
          return [
            { value: "buy-product", name: "I wish to buy a product" },
            { value: "order-question", name: "I have a question about an order I’ve made" },
            { value: "license-issue", name: "I have an issue with my license" },
            { value: "restore-data", name: "I want to restore my user data" },
            { value: "eye-tracking-issue", name: "My eye tracking is not working" },
            { value: "device-issue", name: "My device is malfunctioning" },
            { value: "trial-device", name: "I have a question regarding my trial device" },
            { value: "request-return", name: "Request Return" },
            { value: "other", name: "Other Issues" },
          ];
        }
      },
      getBmTopics: function () {
        return [
          { value: "technical", name: "Technical question about a product" },
          { value: "buy", name: "Questions about how to buy a product or about an order" },
          { value: "other", name: "All other questions" },
        ];
      },
      checkingZipCodeVisibility: function (countrySelect) {
        let selectedCountry = countrySelect.value;
        let zipCodeCountries = ["United States", "Canada", "United Kingdom", "Ireland", "France"];
        if (zipCodeCountries.includes(selectedCountry)) {
          TDForm.helper.showField("zip", true);
        } else {
          TDForm.helper.hideField("zip");
        }
      },
      getSubject: function () {
        let subject = document.getElementById("subject").value;
        return subject + " " + document.getElementById("product_category").selectedOptions[0].value + "_" + document.getElementById("topic").selectedOptions[0].value;
      },
      getRouting: function () {
        let region = document.getElementById("form_region").value;

        switch (region) {
          case "global":
            return app.private.getRoutingForGlobal();
            break;
          case "uk":
            return app.private.getRoutingForUk();
            break;
          case "ca":
            return app.private.getRoutingForCa();
            break;
          case "us":
            return app.private.getRoutingForUs();
            break;
          default:
            return app.private.getRoutingForGlobal();
            break;
        }
      },
      getRoutingForGlobal: function () {
        let routing = { recordType: "", origin: "" };
        let productCategory = document.getElementById("product_category").selectedOptions[0].value;
        let topic = document.getElementById("topic").selectedOptions[0].value;
        let country = document.getElementById("country").selectedOptions[0].value;

        if (country === "United States" || country === "Canada") {
          //non-service
          routing.recordType = "012w0000000Ah9e";
          routing.origin = "support.na@tobiidynavox.com";
          return routing;
        }

        if (productCategory === "AAC") {
          //	EUROW_Case
          routing.recordType = "012w0000000MPYW";

          if (topic === "trial-device") {
            routing.origin = "trials@tobiidynavox.com";
          } else if (topic === "buy-product" || topic === "order-question" || topic === "request-return") {
            routing.origin = "order.eu@tobiidynavox.com";
          } else {
            routing.origin = "support.eu@tobiidynavox.com";
          }
        } else if (productCategory === "BM") {
          //mayer-johnson
          routing.recordType = "012w0000000Ah9d";

          if (topic === "buy") {
            routing.origin = "order.eu@tobiidynavox.com";
          } else {
            routing.origin = "support.eu@tobiidynavox.com";
          }
        }
        return routing;
      },
      getRoutingForUk: function () {
        let routing = { recordType: "", origin: "" };
        let productCategory = document.getElementById("product_category").selectedOptions[0].value;
        let topic = document.getElementById("topic").selectedOptions[0].value;

        if (productCategory === "AAC") {
          //	EUROW_Case
          routing.recordType = "012w0000000MPYW";

          if (topic === "buy-product" || topic === "order-question" || topic === "request-return" || topic === "other") {
            routing.origin = "contact.uk@tobiidynavox.com";
          } else {
            routing.origin = "support.uk@tobiidynavox.com";
          }
        } else if (productCategory === "BM") {
          //mayer-johnson
          routing.recordType = "012w0000000Ah9d";

          if (topic === "technical") {
            routing.origin = "support.eu@tobiidynavox.com";
          } else {
            routing.origin = "contact.uk@tobiidynavox.com";
          }
        }
        return routing;
      },
      getRoutingForCa: function () {
        let routing = { recordType: "", origin: "" };
        let productCategory = document.getElementById("product_category").selectedOptions[0].value;
        let topic = document.getElementById("topic").selectedOptions[0].value;

        if (productCategory === "AAC") {
          if (topic === "buy-product" || topic === "trial-device" || topic === "other") {
            //cx
            routing.recordType = "012QD000001IWaL";
          } else {
            //non-service
            routing.recordType = "012w0000000Ah9e";
          }

          if (topic === "buy-product" || topic === "other") {
            routing.origin = "canada.support@tobiidynavox.com";
          } else if (topic === "order-question" || topic === "funding") {
            routing.origin = "customercare@tobiidynavox.com";
          } else if (topic === "trial-device") {
            routing.origin = "trials@tobiidynavox.com";
          } else {
            routing.origin = "support.na@tobiidynavox.com";
          }
        } else if (productCategory === "BM") {
          if (topic === "technical") {
            //mayer-johnson
            routing.recordType = "012w0000000Ah9d";
            routing.origin = "boardmakersupport.na@tobiidynavox.com";
          } else {
            //cx sales enablement
            routing.recordType = "012QD000001IWaL";
            routing.origin = "boardmakercss@tobiidynavox.com";
          }
        }
        return routing;
      },
      getRoutingForUs: function () {
        let routing = { recordType: "", origin: "" };
        let productCategory = document.getElementById("product_category").selectedOptions[0].value;
        let topic = document.getElementById("topic").selectedOptions[0].value;

        if (productCategory === "AAC") {
          if (topic === "buy-product" || topic === "trial-device" || topic === "other") {
            //cx
            routing.recordType = "012QD000001IWaL";
          } else {
            //non-service
            routing.recordType = "012w0000000Ah9e";
          }

          if (topic === "buy-product" || topic === "other") {
            routing.origin = "css@tobiidynavox.com";
          } else if (topic === "order-question" || topic === "funding") {
            routing.origin = "customercare@tobiidynavox.com";
          } else if (topic === "trial-device") {
            routing.origin = "trials@tobiidynavox.com";
          } else {
            routing.origin = "support.na@tobiidynavox.com";
          }
        } else if (productCategory === "BM") {
          if (topic === "technical") {
            //mayer-johnson
            routing.recordType = "012w0000000Ah9d";
            routing.origin = "boardmakersupport.na@tobiidynavox.com";
          } else {
            //cx sales enablement
            routing.recordType = "012QD000001IWaL";
            routing.origin = "boardmakercss@tobiidynavox.com";
          }
        }
        return routing;
      },
      getCountry: function () {
        let country = document.getElementById("country");
        if (!country) {
          return;
        }
        if (country.selectedOptions && country.selectedOptions.length > 0) {
          return country.selectedOptions[0].value;
        }
        return country.value;
      },
      getCaseValues: function () {
        let routing = app.private.getRouting();
        let c = {
          Subject: app.private.getSubject(),
          RecordTypeId: routing.recordType,
          Origin: routing.origin,
          Country: app.private.getCountry(),
        };

        return JSON.stringify(c);
      },
    },
    helper: {},
    changeHandler: {
      productCategory: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "AAC":
            app.private.productCategory.do_aac();
            break;
          case "BM":
            app.private.productCategory.do_bm();
            break;
          default:
            app.private.productCategory.undo();
            break;
        }
      },
      country: function (select) {
        app.private.checkingZipCodeVisibility(select);
      },
    },
    doSubmit: function () {
      document.getElementById("case_description").value = TDForm.helper.getDescriptionFromIdsPlain();
      document.getElementById("case_values").value = app.private.getCaseValues();
    },
  };
}
